import { IconChevronDown } from "@tabler/icons-react";

export function SelectType({ onChange, value, name }) {
  return (
    <div>
      <div className=" grid grid-cols-1">
        <select
          id="discount_type"
          name={name}
          onChange={onChange}
          value={value}
          className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
        >
          <option value={-1} className="text-slate-300" disabled hidden>
            Select Type
          </option>
          <option value={1}>Percent</option>
          <option value={2}>Flat Rate</option>
          <option value={3}>Tiered</option>
          <option value={4}>Athelete / Fundraiser</option>
        </select>
        <IconChevronDown
          aria-hidden="true"
          className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4"
        />
      </div>
    </div>
  );
}
export function ModifierByType({ type, name, id, onChange, value }) {
  return (
    <>
      {parseInt(type) === 1 && (
        <div className="flex items-center">
          <input
            onChange={onChange}
            value={value}
            id={name}
            name={name}
            type="text"
            placeholder="5"
            className="block w-12 rounded-l-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
          />
          <div className="rounded-r-md py-1.5 px-3 outline outline-1 -outline-offset-1 outline-gray-300 sm:text-sm/6 bg-gray-100">
            %
          </div>
        </div>
      )}
      {parseInt(type) === 2 && (
        <div className="flex items-center">
          <div className="rounded-l-md py-1.5 px-3 outline outline-1 -outline-offset-1 outline-gray-300 sm:text-sm/6 bg-gray-100">
            $
          </div>
          <input
            onChange={onChange}
            value={value}
            id={name}
            name={name}
            type="text"
            placeholder="5"
            className="block w-12 rounded-r-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
          />
        </div>
      )}
      {parseInt(type) === 3 && (
        <div className="flex items-center">
          <div className="rounded-md py-1.5 px-3 outline outline-1 -outline-offset-1 outline-gray-300 sm:text-sm/6 bg-gray-100">
            TODO ask Thomas
          </div>
        </div>
      )}
      {parseInt(type) !== 1 && parseInt(type) !== 2 && parseInt(type) !== 3 && (
        <div className="flex items-center">
          <div className="rounded-md py-1.5 px-3 outline outline-1 -outline-offset-1 outline-gray-300 sm:text-sm/6 bg-gray-100">
            N/A
          </div>
        </div>
      )}
    </>
  );
}
